<div class="fundraiser-sip-banner" *ngIf="vars?.fundraiser?.parent_cause_id!==48" (click)="eventTracking('banner_click')">
  <img data-src="/assets/images/portfolio/childrens_play.png" />
  <div class="banner-content">
    <div *ngIf="!config?.hideEndText" class="pre-title">
      <i class="material-icons">warning_amber</i> <span>This fundraiser has ended.</span></div>
    <div class="title">Gift Smiles with Monthly Giving</div>
    <div class="content">
      <strong>{{subsCount?.campaigns | inrFormat:'INR'}}</strong> Lives Have Been Saved With Monthly Contributions From <strong>{{subsCount?.monthlyDonors | inrFormat:'INR'}}</strong> Contributors. Save Countless Lives By Giving Monthly.
    </div>
    <button (click)="eventTracking('button_click')" mat-button>Start Monthly Giving <i class="material-icons">east</i></button>
  </div>
</div>

<!-- Dock button if sip banner present -->
<div *ngIf="!config.hideDock && vars?.fundraiser?.parent_cause_id!==48" class="fundraiser-sip-banner-dock">
  <div class="title">Help others that need urgent medical care.</div>
  <button color="primary" mat-raised-button (click)="eventTracking('button_click')">Create More Impact</button>
</div>
